import { Address } from "viem"
import { IS_TESTNET, USDC_CONTRACT_ADDRESS, WETH_CONTRACT_ADDRESS, ZERO_ADDRESS } from "./constants"
import { formatBalance } from "./utils/formatBalance"

export class Token {
  public readonly name: string
  public readonly symbol: string
  public readonly address: Address
  public readonly decimals: number
  public readonly icon: string

  constructor({ name, symbol, address, decimals, icon }
    : { name: string, symbol: string, address: Address, decimals: number, icon: string }) {
    this.name = name
    this.symbol = symbol
    this.address = address
    this.decimals = decimals
    this.icon = icon
  }

  wrapped() {
    if (this.address === ZERO_ADDRESS)
      return WETH_CONTRACT_ADDRESS
    return this.address
  }
}

export class TokenBalance {
  public readonly token: Token
  public readonly balance: bigint

  constructor({ token, balance }: { token: Token, balance: bigint }) {
    this.token = token
    this.balance = balance
  }

  public get formattedBalance(): string {
    return formatBalance(this.balance, this.token.decimals);
  }
}
  
export const TOKENS: Record<Address, Token> = {
  [ZERO_ADDRESS]: new Token({
    name: 'Ethereum',
    symbol: 'ETH',
    address: ZERO_ADDRESS,
    decimals: 18,
    icon: "https://token-icons.s3.amazonaws.com/eth.png",
  }),
  [WETH_CONTRACT_ADDRESS]: new Token({
    name: 'Ethereum',
    symbol: 'ETH',
    address: WETH_CONTRACT_ADDRESS,
    decimals: 18,
    icon: "https://token-icons.s3.amazonaws.com/eth.png",
  }),
  [USDC_CONTRACT_ADDRESS]: new Token({
    name: 'USD Coin',
    symbol: 'USDC',
    address: USDC_CONTRACT_ADDRESS,
    decimals: 6,
    icon: "https://coin-images.coingecko.com/coins/images/6319/large/usdc.png"
  }),
}

if (IS_TESTNET) {
  TOKENS['0x740810c5CB6a562BC0F4F387dC7cFaDa9f3A7ebf'] = new Token({
    name: 'Ethereum',
    symbol: 'ETH',
    address: '0x740810c5CB6a562BC0F4F387dC7cFaDa9f3A7ebf',
    decimals: 18,
    icon: "https://token-icons.s3.amazonaws.com/eth.png",
  })
}

export const TOKENS_EXCEPT_WETH = Object.fromEntries(Object.entries(TOKENS).filter(([address]) => address !== WETH_CONTRACT_ADDRESS))